import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldset", "options", "projectSelect"]
  static values = {
    projects: Object,
    selectedIds: Array,
    formId: String,
    inputName: { type: String, default: "issue[app_type_ids][]" }
  }

  connect() {
    this.onProjectChange = this.projectChanged.bind(this)
    this.watchedSelects().forEach((select) => select.addEventListener("change", this.onProjectChange))
    this.render()
  }

  disconnect() {
    this.watchedSelects().forEach((select) => select.removeEventListener("change", this.onProjectChange))
  }

  projectChanged() {
    this.selectedIdsValue = []
    this.render()
  }

  selectAll(event) {
    event.preventDefault()
    this.optionsTarget.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.checked = true
    })
  }

  render() {
    const appTypes = this.projectsValue[String(this.currentProjectId())] || []

    if (!appTypes.length) {
      this.fieldsetTarget.classList.add("hidden")
      this.optionsTarget.innerHTML = this.hiddenBlankInput()
      return
    }

    this.fieldsetTarget.classList.remove("hidden")
    const selected = new Set(this.selectedIdsValue.map(String))
    const boxes = appTypes.map((appType) => this.checkboxHtml(appType, selected.has(String(appType.id)))).join("")
    const selectAll = appTypes.length > 1
      ? `<button type="button" data-action="app-type-picker#selectAll" class="text-sm font-medium text-indigo-600 hover:text-indigo-500">Select all</button>`
      : ""

    this.optionsTarget.innerHTML = `${this.hiddenBlankInput()}<div class="flex flex-wrap items-center gap-3">${boxes}${selectAll}</div>`
  }

  currentProjectId() {
    const visible = this.watchedSelects().find((select) => select.offsetParent !== null)
    return (visible || this.watchedSelects()[0])?.value || ""
  }

  watchedSelects() {
    const selects = []
    if (this.hasProjectSelectTarget) selects.push(...this.projectSelectTargets)

    const root = this.element.closest("turbo-frame") || this.element.closest("form") || document
    root.querySelectorAll("select[name='issue[project_id]']").forEach((select) => {
      if (!selects.includes(select)) selects.push(select)
    })

    return selects
  }

  hiddenBlankInput() {
    return `<input type="hidden" name="${this.inputNameValue}" value=""${this.formAttribute()}>`
  }

  checkboxHtml(appType, checked) {
    const checkedAttr = checked ? " checked" : ""
    return `
      <label class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm cursor-pointer hover:border-indigo-300">
        <input type="checkbox" name="${this.inputNameValue}" value="${appType.id}" class="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"${checkedAttr}${this.formAttribute()}>
        <span>${this.escape(appType.name)}</span>
      </label>
    `
  }

  formAttribute() {
    return this.hasFormIdValue && this.formIdValue ? ` form="${this.formIdValue}"` : ""
  }

  escape(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
  }
}
